angular.module('eStories.mobileApps', [])
    .config(['$stateProvider', function ($stateProvider) {
        $stateProvider
            .state('eStories.navbars.mobileApps', {
                url: 'apps',
                views: {
                    'mainView@': {
                        templateUrl: 'home/mobileApps/mobileApps.tmpl.html',
                        controller: 'MobileAppsCtrl',
                        controllerAs: 'mobileAppsCtrl'
                    }
                }
            })
            .state('eStories.navbars.affiliates', {
                url: 'affiliates',
                views: {
                    'mainView@': {
                        templateUrl: 'home/affiliates.tmpl.html',
                        controller: 'MobileAppsCtrl',
                        controllerAs: 'mobileAppsCtrl'
                    }
                }
            });
    }])
    .controller('MobileAppsCtrl', ['AccountModel', 'SeoModel', '$state', 'GA', '$location',
        function (AccountModel, SeoModel, $state, GA, $location) {

        var mobileAppsCtrl = this;

        GA.trackPageView($location.path());

        SeoModel.applyMetaTags($state.current.name);

    }]);